/**
 * Builds the `widgets` array for the create/update-template payload from the
 * widgets held by the MOS grid. Template items carry no identity, so the
 * client-side `id` (and any transient grid metadata) is dropped, and `data` is
 * serialized back to a JSON string (opaque to the backend).
 *
 * Kept free of heavy imports on purpose: consumers that only save (e.g. the
 * template manager dialog) should not transitively pull the widget registry
 * or the ESM `uuid` dependency that `parseTemplateWidgets` needs.
 */
export const serializeTemplateWidgets = (widgets) => {
  if (!Array.isArray(widgets)) return []

  return widgets.map((widget) => ({
    type: widget.type,
    x: widget.x,
    y: widget.y,
    w: widget.w,
    h: widget.h,
    data: widget.data ? JSON.stringify(widget.data) : null
  }))
}
